export default "__VITE_ASSET__4HI87522__"